import { Component, Inject, Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json'
  })
};
@Injectable({ providedIn: 'root' })

export class LogoutService {

  baseurl: string
  constructor(private http: HttpClient) { }

  logout(logid: string) {
    
    this.baseurl = environment.serviceUrl;
    let header = new HttpHeaders();
    header = header.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.post(this.baseurl + 'api/UserApi/logout/'+logid, { logid }, { headers: header, observe: 'response' });
  }

}
